export default {
  strings: {
    nav: {
      home: "الرئيسية",
      services: "الخدمات",
      personal: "الدعم الشخصي",
      about: "من نحن",
      packages: "الباقات",
      faq: "الأسئلة الشائعة",
      contact: "اتصل بنا",
      book: "احجز استشارة",
    },
    common: {
      book: "احجز استشارة",
      quote: "اطلب عرض سعر",
      viewServices: "عرض الخدمات",
    },
    whatsapp: {
      label: "تحدث عبر واتساب",
      prefill: "مرحبًا VCK Business Lab! أود الاستفسار عن خدماتكم.",
    },
    footer: {
      tagline: "دعم افتراضي راقٍ للأعمال الحديثة",
      blurb:
        "دعم إداري افتراضي موثوق وسري ودقيق — يُقدَّم افتراضيًا بنسبة 100% للعملاء في كندا والولايات المتحدة وأوروبا ودوليًا.",
      explore: "استكشف",
      services: "الخدمات",
      ownerLogin: "دخول المالك",
      rights: "VCK Business Lab. جميع الحقوق محفوظة.",
      virtual: "افتراضي 100% · حول العالم",
      quote: "اطلب عرض سعر",
    },
    cta: {
      overline: "دعنا نتولى التفاصيل.",
      title: "اقضِ وقتًا أقل في الإدارة ووقتًا أطول في دفع أعمالك إلى الأمام.",
      book: "احجز استشارة",
      quote: "اطلب عرض سعر",
    },
    home: {
      heroOverline: "VCK Business Lab · افتراضي 100% · حول العالم",
      heroLine1: "دعم افتراضي احترافي",
      heroLine2: "للأعمال وللحياة اليومية.",
      heroSub:
        "دعم إداري وتجاري ومتعدد اللغات للشركات والمهنيين والأفراد والقادمين الجدد — يُقدَّم افتراضيًا بنسبة 100% في كندا وحول العالم.",
      heroStats: [
        { stat: "100%", label: "تقديم افتراضي من أي مكان" },
        { stat: "حول العالم", label: "كندا · الولايات المتحدة · أوروبا · وخارجها" },
        { stat: "بوتيك", label: "دعم شخصي وسري" },
      ],
      extOverline: "امتداد لأعمالك",
      extTitle: "دعم موثوق دون توظيف موظف بدوام كامل.",
      extCopy:
        "تعمل VCK Business Lab كامتداد سلس لأعمالك — حيث تقدم دعمًا إداريًا موثوقًا وسريًا ودقيقًا دون تكلفة أو التزام توظيف موظف بدوام كامل.",
      extPoints: [
        { title: "الموثوقية", text: "دعم ثابت ومنتظم يمكنك التخطيط على أساسه." },
        { title: "السرية", text: "تُعامل معلومات عملك بسرية صارمة وبضمانات معقولة." },
        { title: "الدقة في التفاصيل", text: "كل مهمة تُنجز بعناية وبمعايير عالية." },
      ],
      svcOverline: "الخدمات",
      svcTitle: "كل ما على مكتبك، يُنجَز بهدوء.",
      svcCopy: "مجالات دعمنا — تُقدَّم افتراضيًا ومصممة حول طريقة عملك وحياتك.",
      svcViewAll: "استكشف جميع الخدمات",
      svcViewDetails: "عرض التفاصيل",
      splitOverline: "دعم مصمم من أجلك",
      splitTitle: "مساران. معيار واحد من العناية.",
      splitCopy: "سواء كنت تدير عملًا أو تبني حياة جديدة، تلقاك VCK أينما كنت.",
      splitBizTitle: "خدمات الأعمال",
      splitBizText:
        "دعم افتراضي إداري وتنفيذي ومتعدد اللغات وللمستندات والمشاريع ومواقع الويب للشركات ورواد الأعمال والمهنيين حول العالم.",
      splitBizPoints: ["الدعم الإداري ودعم المديرين التنفيذيين", "الترجمة والتواصل متعدد اللغات", "المستندات والمشاريع والمواقع الإلكترونية"],
      splitBizCta: "استكشف خدمات الأعمال",
      splitPerTitle: "الدعم الشخصي ودعم القادمين الجدد",
      splitPerText:
        "دعم صبور وسري للأفراد والعائلات والقادمين الجدد إلى كندا — مهامك اليومية تُنجَز بلغتك.",
      splitPerPoints: ["المساعدة اللغوية ومساعدة التواصل", "المساعدة في التأمين والخدمات المصرفية والمرافق", "السكن والمدارس والإدارة اليومية"],
      splitPerCta: "استكشف الدعم الشخصي",
      stepsOverline: "كيف نعمل",
      stepsTitle: "من أول مكالمة إلى التركيز الكامل، في أربع خطوات.",
      whyOverline: "لماذا تختار VCK",
      whyTitle: "المعيار الذي تستحقه أعمالك.",
      whyCopy: "أكثر من مجرد إنجاز المهام — شراكة مهنية مبنية على الثقة والدقة والسرية.",
      whoOverline: "مع من نعمل",
      whoTitle: "موضع ثقة الأشخاص الذين يحركون عجلة الأعمال.",
      testOverline: "آراء العملاء",
      testTitle: "قصص العملاء.",
      testLaunch: "نرحب حاليًا بأول عملائنا الأوائل. ستُضاف تجارب العملاء ودراسات الحالة مع نمو VCK.",
      packOverline: "خطط الدعم المستمر",
      packTitle: "دعم شهري مصمم حولك.",
      packCopy:
        "باقات شهرية مرنة بالدولار الأمريكي — وليست اشتراكات جامدة أبدًا. يتم تأكيد السعر النهائي معًا بعد استشارة قصيرة.",
      packViewAll: "عرض الباقات",
      packIncluded: "ما الذي يتضمنه",
      packGlobalTitle: "Global Priority",
      packGlobalText:
        "دعم دولي متعدد اللغات بساعات ممتدة أو بأحجام أكبر — ترتيبات شهرية مخصصة بالكامل مع سير عمل مخصص وأسعار طوارئ مخفّضة.",
      packGlobalBtn: "اطلب عرض سعر مخصص",
      faqOverline: "أسئلة شائعة",
      faqTitle: "الإجابات، قبل أن تسأل.",
      faqViewAll: "عرض جميع الأسئلة",
      loyaltyText: "العملاء الدائمون يحصلون على ما يصل إلى 36 ساعة دعم مجانية ومزايا أولوية وحزمة ترحيب من VCK.",
      loyaltyCta: "اكتشف مزايا الولاء",
    },
    services: {
      overline: "الخدمات والأسعار",
      line1: "خدمات مصممة حول",
      line2: "احتياجاتك.",
      intro:
        "من الإدارة اليومية إلى التواصل متعدد اللغات والدعم الدولي العاجل، تقدم VCK Business Lab دعمًا مرنًا متعدد اللغات للشركات والمهنيين والقادمين الجدد والطلاب الدوليين والعملاء الدوليين.",
      languages: "English | Українська | العربية | Other Languages",
      worldwide: "نخدم العملاء حول العالم • افتراضي 100%",
      showLess: "عرض أقل",
      pricing: "الأسعار",
      plansOverline: "خطط الدعم المستمر",
      plansTitle: "دعم شهري مصمم حولك.",
      plansCopy: "هذه ليست اشتراكات جامدة — يمكن تخصيص كل خطة وفق ساعاتك وخدماتك ولغاتك وأولوياتك.",
      disOverline: "أسعار مرنة لكل عمل",
      disQuote:
        "«الأسعار المعروضة هي أسعار بداية بالدولار الأمريكي. يعتمد السعر النهائي على التعقيد وتركيبة اللغات وسرعة التنفيذ والخبرة المطلوبة والحجم ومتطلبات الخدمة. تتوفر باقات شهرية وتسعير على أساس المشاريع.»",
      disNote: "لا يلزم أي التزام طويل الأمد ما لم يُتفق عليه في عقد خدمة.",
    },
    packages: {
      availabilityNote: "الأسعار المعروضة أسعار ابتدائية، وجميع الخدمات خاضعة للتوفر. يتم تأكيد النطاق والمخرجات والمواعيد النهائية والرسوم والمراجعات في عرض سعر أو اتفاق مكتوب.",
      overline: "الباقات",
      line1: "دعم يتوسع مع",
      line2: "عبء عملك.",
      intro:
        "كل تعاون يبدأ بسعر مبدئي يُخصَّص بعد استشارة قصيرة — فتدفع فقط مقابل الدعم الذي تحتاجه فعلًا. لا ضغط للشراء؛ ابدأ بطلب عرض سعر.",
      note: "هذه ليست اشتراكات جامدة — يمكن تخصيص كل خطة وفق ساعاتك وخدماتك ولغاتك وأولوياتك.",
      mostRequested: "الأكثر طلبًا",
      startingFrom: "ابتداءً من",
      tailored: "مخصص",
      requestQuote: "اطلب عرض سعر",
      quoteNote: "لا يوجد دفع عبر الموقع — بعد تأكيد النطاق والسعر، نرسل لك رابط دفع آمنًا مباشرة.",
      compareOverline: "قارن الباقات",
      compareTitle: "اعثر على ما يناسبك بنظرة واحدة.",
      compareIncluded: "يتضمن",
      disOverline: "أسعار مرنة لكل عمل",
      disQuote:
        "«الأسعار المعروضة هي أسعار بداية بالدولار الأمريكي. يعتمد السعر النهائي على التعقيد وتركيبة اللغات وسرعة التنفيذ والخبرة المطلوبة والحجم ومتطلبات الخدمة. تتوفر باقات شهرية وتسعير على أساس المشاريع.»",
      disNote: "لا يلزم أي التزام طويل الأمد ما لم يُتفق عليه في عقد خدمة.",
      loyaltyOverline: "مكافآت ولاء العملاء",
      loyaltyTitle: "دعم أكثر. قيمة أكبر. أسباب أكثر للبقاء.",
      loyaltyIntro:
        "في VCK Business Lab، نقدّر الشراكات طويلة الأمد. عندما تختار خطة دعم مستمرة، نشكرك بساعات دعم مجانية ومزايا أولوية وهدية ترحيب من VCK.",
      bestValue: "أفضل قيمة",
      welcomeOverline: "شيء صغير من VCK",
      welcomeTitle: "كل عميل جديد طويل الأمد يستحق أن يشعر بالترحيب.",
      welcomeText:
        "يحصل العملاء المؤهلون على حزمة ترحيب مجانية من VCK، أُعدّت بعناية كشكر لاختيارك لنا شريكًا لدعم أعمالك.",
      welcomeNote: "دون أي رسوم إضافية — مجرد طريقتنا لنقول: أهلًا بك في VCK.",
      welcomeInclude: "قد تتضمن حزمتك",
      welcomeItems: ["أساسيات مكتبية فاخرة", "إكسسوارات أعمال", "منتجات تحمل علامة VCK", "هدية ترحيب شخصية"],
      bonusOverline: "ساعاتك الإضافية، خيارك",
      bonusTitle: "استخدم ساعاتك الإضافية عندما تحتاج يدًا مساعدة إضافية.",
      bonusText: "يمكن استخدام الساعات المجانية في خدمات VCK المؤهلة، بما في ذلك:",
      builtOverline: "مصمم حول أعمالك",
      builtTitle: "لست متأكدًا أي باقة تناسبك؟",
      builtText: "يمكننا إنشاء خطة دعم بناءً على عبء عملك ولغاتك ومنطقتك الزمنية واحتياجات أعمالك.",
      builtBook: "احجز استشارة مجانية",
      builtOr: "أو",
      builtQuote: "اطلب عرض السعر المخصص لك",
      welcomeLine: "أهلًا بك في VCK Business Lab",
      welcomeTagline: "دعم عالمي · خبرة متعددة اللغات · شريك أعمال يمكنك الاعتماد عليه",
      referOverline: "برنامج الإحالة",
      referTitle: "شارك VCK. واحصل على دعم مجاني.",
      referIntro:
        "تحب العمل مع VCK Business Lab؟ أحِل شركة أخرى واحصل على ساعات دعم مجانية عندما تصبح عميلاً لدى VCK.",
      referSteps: [
        {
          title: "أحِل شركة",
          text: "عرّف VCK Business Lab إلى شركة أو مهني أو رائد أعمال يمكنه الاستفادة من خدماتنا.",
        },
        { title: "ينضمون إلى VCK", text: "توقّع إحالتك باقة التزام مؤهلة من VCK." },
        {
          title: "تحصل على ساعات مجانية",
          text: "بمجرد بدء اتفاقيتهم، تُضاف ساعات الدعم المجانية إلى حسابك كشكر منا.",
        },
      ],
      referRewardsTitle: "مكافآت الإحالة",
      referTiers: [
        { plan: "إحالة توقّع باقة شهر واحد", hours: "احصل على ساعتين مجانيتين" },
        { plan: "إحالة توقّع باقة 3 أشهر", hours: "احصل على 5 ساعات مجانية" },
        { plan: "إحالة توقّع باقة 6 أشهر", hours: "احصل على 10 ساعات مجانية" },
        { plan: "إحالة توقّع باقة 12 شهرًا", hours: "احصل على 20 ساعة مجانية" },
      ],
      referMoreTitle: "أحِل أكثر. اربح أكثر.",
      referMoreText:
        "لا حاجة للتوقف عند إحالة واحدة. أحِل عدة شركات واستمر في كسب ساعات دعم VCK المجانية كلما أصبحت الإحالات المؤهلة عملاء.",
      referMilestones: [
        { count: "3 إحالات ناجحة", reward: "احصل على 5 ساعات إضافية" },
        { count: "5 إحالات ناجحة", reward: "احصل على 10 ساعات إضافية" },
        { count: "10 إحالات ناجحة", reward: "مكافأة ولاء خاصة من VCK بالإضافة إلى دعم مجاني إضافي" },
      ],
      referThanksOverline: "شكرًا لنموك معنا",
      referThanksText:
        "أعمالنا تنمو عبر العلاقات، ونريد أن يستفيد عملاؤنا عندما يعرّفون الآخرين بـ VCK. يمكن استخدام ساعات الإحالة المجانية في خدمات مؤهلة مثل:",
      referServices: [
        "الدعم الإداري الافتراضي",
        "دعم المديرين التنفيذيين",
        "دعم الأعمال متعدد اللغات",
        "خدمات المستندات والمشاريع",
        "خدمات الترجمة",
        "خدمات VCK المؤهلة الأخرى",
      ],
      referCtaTitle: "هل تعرف شركة يمكن أن تستفيد من VCK؟",
      referCtaText: "ساعد شركة أخرى على اكتشاف دعم عالمي موثوق — واستمتع بساعات VCK إضافية علينا.",
      referCtaBtn: "أحِل شركة",
    },
    about: {
      overline: "عن VCK",
      line1: "شريك بوتيك للعمل",
      line2: "الذي يقف وراء عملك.",
      intro:
        "أُنشئت VCK Business Lab لتزويد الشركات والمهنيين بدعم إداري افتراضي موثوق ومنظم وعالي الجودة — بعناية شركة بوتيك، لا ببرود شركة كبيرة.",
      storyOverline: "لماذا نحن موجودون",
      storyTitle: "أُنشئنا لنُعيد إليك وقتك.",
      storyP1:
        "العمل الإداري الروتيني يستهلك بهدوء أكثر الساعات أهمية. توجد VCK Business Lab لترفع هذا العبء عن مكتبك — لتسهيل العمليات التجارية بدعم مهني مرن دون تكلفة والتزام توظيف موظف إضافي بدوام كامل.",
      storyP2:
        "الاحترافية والتنظيم والتواصل والسرية والاهتمام بالتفاصيل ليست كلمات تسويقية هنا — بل هي معيار العمل وراء كل بريد وثيقة واجتماع.",
      manOverline: "مبادئنا",
      manTitle: "ثلاثة التزامات نفي بها يوميًا.",
      globalOverline: "الانتشار العالمي",
      globalTitle: "أينما تعمل، نعمل نحن أيضًا.",
      globalCopy: "تُقدَّم جميع الخدمات افتراضيًا بنسبة 100%، مما يتيح لـ VCK دعم العملاء بسلاسة عبر المناطق الزمنية والحدود.",
      regions: ["كندا", "الولايات المتحدة", "أوروبا", "دولي"],
      valuesOverline: "قيمنا الأساسية",
      valuesTitle: "ما يمكنك توقعه، في كل مرة.",
      whoOverline: "مع من نعمل",
      whoTitle: "مصمم للأشخاص المشغولين والأعمال النامية.",
    },
    faqPage: {
      overline: "الأسئلة الشائعة",
      line1: "الإجابات، قبل",
      line2: "أن تسأل.",
      intro: "الأسئلة الأكثر شيوعًا التي يطرحها العملاء حول العمل مع VCK Business Lab. إذا لم تجد سؤالك هنا، نحن على بعد رسالة واحدة.",
      calloutOverline: "لا يزال لديك سؤال؟",
      calloutTitle: "لنتحدث عنها — دون أي التزام.",
      calloutText: "الاستشارة التعريفية المجانية هي أسهل طريقة للحصول على إجابات خاصة بأعمالك.",
      calloutBtn: "احجز استشارة مجانية",
    },
    contact: {
      overline: "اتصل بنا",
      line1: "لنتحدث عن",
      line2: "عبء عملك.",
      intro: "أخبرنا بما تريد رفعه عن مكتبك. كل استفسار يتلقى ردًا شخصيًا خلال يوم عمل واحد.",
      consultTitle: "احجز استشارة مجانية",
      consultText:
        "حدد موعد استشارة تعريفية مجانية لمناقشة احتياجات أعمالك — دون التزام أو ضغط. سنوصي بنوع ومستوى الدعم الأنسب لك.",
      consultPoints: [
        "مكالمة تعريفية في الوقت الذي يناسبك",
        "توصية مخصصة لعبء عملك",
        "لا التزام بالمتابعة إطلاقًا",
      ],
      consultBtn: "احجز استشارة مجانية",
      consultNote:
        "تُقدَّم جميع الخدمات افتراضيًا بنسبة 100%. نرحب ترحيبًا حارًا باستفسارات العملاء الدوليين — من كندا والولايات المتحدة وأوروبا وخارجها.",
      trackLabel: "أتواصل بصفتي",
      trackBusiness: "شركة / عمل",
      trackPersonal: "فرد / قادم جديد",
      trackRequired: "يرجى تحديد ما إذا كنت تتواصل بصفتك شركة أم فردًا.",
      formTitle: "أرسل استفسارًا",
      formSub: "اطلب عرض سعر أو اطرح سؤالًا — وسنتولى الأمر من هناك.",
      name: "الاسم",
      company: "الشركة",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      country: "البلد",
      support: "نوع الدعم المطلوب",
      hours: "الساعات التقديرية أسبوعيًا",
      preferred: "طريقة التواصل المفضلة",
      description: "وصف المشروع",
      optional: "— اختياري",
      phName: "اسمك الكامل",
      phCompany: "الشركة أو المنصب",
      phEmail: "you@company.com",
      phPhone: "+___ __ ___ ____",
      phCountry: "أين تقيم",
      phDescription: "أخبرنا عن المهام أو المشاريع التي تحتاج دعمًا فيها…",
      selectService: "اختر خدمة",
      selectHours: "اختر تقديرًا",
      selectPreferred: "كيف نتواصل معك؟",
      freeConsultation: "استشارة مجانية",
      customProject: "مشروع مخصص",
      notSure: "لست متأكدًا بعد",
      hoursOptions: ["1–5 ساعات", "5–10 ساعات", "10–20 ساعة", "20+ ساعة", "مشروع لمرة واحدة", "لست متأكدًا بعد"],
      contactOptions: ["البريد الإلكتروني", "الهاتف", "مكالمة فيديو"],
      planPrefill: "أود طلب عرض سعر لباقة {name}.",
      referralPrefill: "أود إحالة شركة إلى VCK Business Lab.",
      submit: "أرسل الاستفسار",
      sending: "جارٍ الإرسال…",
      successTitle: "شكرًا لك — تم استلام استفسارك.",
      successText: "سنرد خلال يوم عمل واحد. رسالة تأكيد في طريقها إليك.",
      errorTitle: "حدث خطأ أثناء إرسال استفسارك.",
      errorText: "يرجى المحاولة مرة أخرى بعد قليل.",
    },
    personal: {
      overline: "الدعم الشخصي ودعم القادمين الجدد",
      line1: "دعم يومي من أجل",
      line2: "الحياة في بلد جديد.",
      intro:
        "الانتقال إلى بلد جديد — أو حتى إدارة حياة شخصية مزدحمة — يأتي مع رسائل ومكالمات ونماذج ومواعيد، غالبًا بلغة ليست لغتك الأولى. تقدم VCK Business Lab دعمًا افتراضيًا صبورًا وسريًا للأفراد والعائلات والقادمين الجدد إلى كندا.",
      languages: "English | Українська | العربية",
      worldwide: "نخدم الأفراد والعائلات حول العالم • افتراضي ⁦100%⁩",
      whoOverline: "لمن هذا الدعم",
      whoTitle: "دعم للحظات التي تهمك.",
      whoList: ["القادمون الجدد إلى كندا", "الأفراد والعائلات", "كبار السن", "الطلاب", "المهنيون المشغولون", "كل من لغته الإنجليزية محدودة"],
      svcOverline: "كيف نساعد",
      svcTitle: "دعم شخصي — بلغتك.",
      svcCopy: "دعم للمهام اليومية المتعلقة بالاستقرار والتنظيم — يُقدَّم افتراضيًا وبصبر وسرية تامة.",
      services: [
        {
          title: "المساعدة اللغوية",
          text: "الرسائل والبريد الإلكتروني والنماذج والمكالمات الهاتفية اليومية — مفهومة ومجابة بلغتك.",
          items: ["فهم الرسائل الرسمية والبريد الإلكتروني", "المساعدة في تعبئة النماذج اليومية", "دعم المكالمات الهاتفية بلغتك", "ترجمة يومية غير معتمدة"],
        },
        {
          title: "التواصل مع التأمين والبنوك",
          text: "تواصل واضح وواثق مع البنوك وشركات التأمين ومقدمي الخدمات.",
          items: ["التحضير لمكالمات البنك والتأمين", "فهم المراسلات وكشوف الحسابات", "جدولة المواعيد", "رسائل متابعة نيابة عنك"],
        },
        {
          title: "المرافق والفواتير",
          text: "توصيل الخدمات ومتابعة الالتزامات الشهرية.",
          items: ["إعداد حسابات الإنترنت والهاتف والمرافق", "فهم الفواتير الشهرية", "ترتيب مواعيد الخدمة", "مقارنة خيارات الخطط"],
        },
        {
          title: "دعم السكن",
          text: "مساعدة هادئة ومنظمة خلال عملية الإيجار.",
          items: ["التواصل مع المُلاّك وشركات إدارة العقارات", "جدولة المعاينات", "فهم المراسلات المتعلقة بالإيجار", "قوائم التحقق عند الانتقال والمغادرة"],
        },
        {
          title: "المدارس والعائلة",
          text: "دعم التنسيق اليومي لعائلتك.",
          items: ["دعم التسجيل في المدارس", "التواصل بين أولياء الأمور والمعلمين", "نماذج البرامج المجتمعية", "جدولة أنشطة الأطفال"],
        },
        {
          title: "الإدارة اليومية",
          text: "المهام الصغيرة التي تتراكم بهدوء — تُنجَز عنك.",
          items: ["حجز المواعيد والتذكيرات", "تنظيم المستندات الشخصية", "تنسيق السير الذاتية وخطابات التقديم", "إدارة التقويم والجدول"],
        },
      ],
      stepsOverline: "كيف نعمل",
      stepsTitle: "ببساطة — منذ الرسالة الأولى.",
      steps: [
        { title: "أخبرنا", text: "شاركنا ما تحتاج المساعدة فيه — بلغتك، برسالة أو عبر استشارة مجانية." },
        { title: "نؤكد", text: "نؤكد نطاق العمل وسعرًا مبدئيًا واضحًا قبل بدء أي عمل." },
        { title: "نتولى الأمر", text: "المكالمات والنماذج والرسائل والترتيبات — بصبر وسرية تامة." },
        { title: "تبقى على اطلاع", text: "تحديثات واضحة بلغتك في كل خطوة." },
      ],
      disOverline: "معلومات مهمة",
      disTitle: "حدود واضحة — عن قصد.",
      disIntro: "تقدم VCK Business Lab الدعم الإداري والتنظيمي والتواصلي فقط. ونحن حريصون — وشفافون — بشأن ما لا نقدمه.",
      disclaimers: [
        {
          title: "لا استشارات هجرة",
          text: "لا تقدم VCK Business Lab نصائح أو استشارات في شؤون الهجرة، ولا تُعد أو تراجع أو تقدم طلبات الهجرة. لشؤون الهجرة، يُرجى استشارة مستشار هجرة كندي مرخص (RCIC) أو محامي هجرة.",
        },
        {
          title: "لا نصائح قانونية أو مالية أو تأمينية",
          text: "لا نقدم نصائح قانونية أو مالية أو تأمينية أو ضريبية أو طبية. دورنا هو التواصل والتنظيم والإدارة — أما القرارات فتبقى دائمًا لك وللمختصين المرخصين لديك.",
        },
        {
          title: "ترجمة غير معتمدة فقط",
          text: "الترجمات المقدمة ضمن الدعم الشخصي هي ترجمات عامة غير معتمدة للفهم اليومي. لا نقدم ترجمات معتمدة أو محلفة أو موثقة أو مقبولة قضائيًا.",
        },
        {
          title: "المختص المناسب دائمًا",
          text: "عندما تتطلب حالتك مختصًا مرخصًا أو خاضعًا للتنظيم، سنخبرك بذلك دائمًا — ونساعدك في العثور على المختص المناسب.",
        },
      ],
      partnerOverline: "دعم إداري ولغوي بعد الوصول في كندا",
      partnerTitle: "نحن نُكمل عمل المختصين الذين يساعدونك على الوصول.",
      partnerLine: "أنت تساعد عملاءك على الوصول إلى كندا. وVCK Business Lab تدعمهم بعد وصولهم.",
      partnerText:
        "تعمل VCK Business Lab جنبًا إلى جنب مع مستشاري الهجرة والوكالات التعليمية والكليات وشركات التوظيف وشركات الانتقال — وليس بديلًا عنهم أبدًا.",
      partnerTypesLabel: "من يحيل العملاء إلينا",
      partnerTypes: ["مستشارو الهجرة (RCIC) والمحامون", "الوكالات التعليمية والكليات", "شركات التوظيف وأصحاب العمل", "شركات الانتقال والتوطين", "منظمات الاستقرار والمجتمع"],
      partnerWhyTitle: "لماذا يحيل الشركاء عملاءهم إلى VCK",
      partnerWhy: [
        { title: "بلغتهم", text: "يحصل العملاء على الدعم بالإنجليزية والأوكرانية والعربية ولغات أخرى — دون أن يضيع شيء في الترجمة." },
        { title: "حدود واضحة", text: "نقدم الدعم الإداري واللغوي فقط — ولا نقدم أبدًا استشارات هجرة أو نصائح خاضعة للتنظيم، لذلك نُكمل عملك ولا ننافسه." },
        { title: "سرعة وموثوقية", text: "يحصل كل عميل مُحال على رد خلال يوم عمل واحد واستشارة تعريفية مجانية." },
        { title: "سرية تامة افتراضيًا", text: "تُعالج معلومات العملاء بسرية صارمة، مع توفر اتفاقيات سرية عند الحاجة." },
      ],
      partnerCta: "ناقش شراكة الإحالة",
      ctaOverline: "لست مضطرًا لمعالجة كل شيء بمفردك.",
      ctaTitle: "أخبرنا بما تحتاج — بلغتك.",
      ctaText: "الاستشارة التعريفية المجانية هي أسهل طريقة للبدء. بلا التزام ولا ضغط.",
    },
  },
  data: {
    services: [
      {
        title: "دعم الأعمال والمديرين التنفيذيين الافتراضي",
        tagline: "دعم إداري وتنفيذي احترافي عن بُعد لرواد الأعمال والمديرين والمهنيين والشركات حول العالم.",
        price: "ابتداءً من $30 USD/ساعة",
        featured: ["إدارة البريد والوارد", "التقويم والجدولة", "مساعدة المديرين التنفيذيين", "تنسيق الاجتماعات", "إدارة المشاريع"],
        moreLabel: "عرض جميع خدمات دعم الأعمال",
        groups: [
          {
            heading: null,
            items: [
              "إدارة البريد الإلكتروني والوارد",
              "إدارة التقويم",
              "جدولة المواعيد",
              "جدولة الاجتماعات",
              "تنسيق الاجتماعات",
              "إدارة تقويم المديرين التنفيذيين",
              "دعم المساعد الافتراضي العام",
              "المساعدة الإدارية",
              "إدخال البيانات",
              "تنظيم الملفات",
              "الأرشفة الرقمية",
              "تحديث قواعد البيانات",
              "البحث عبر الإنترنت",
              "المتابعات الإدارية",
              "تتبع المهام",
              "صيانة جداول البيانات",
              "إعداد جداول الأعمال",
              "محاضر الاجتماعات",
              "ملاحظات الاجتماعات",
              "تتبع إجراءات المتابعة",
              "المراسلات المهنية",
              "بحث السفر",
              "تنسيق السفر",
              "تنسيق الفعاليات",
              "إدارة المشاريع",
              "تنسيق أصحاب المصلحة",
              "تنظيم الأعمال",
              "دعم إداري سري",
              "إعداد العروض التقديمية",
              "أدوات التتبع الداخلية",
              "دعم التقارير",
              "تغطية إدارية مؤقتة",
              "دعم إداري شهري مستمر",
            ],
          },
        ],
        pricing: [
          { label: "الدعم المنتظم", value: "ابتداءً من $30/ساعة" },
          { label: "الدعم ذو الأولوية", value: "ابتداءً من $45/ساعة" },
          { label: "الباقات الشهرية", value: "متاحة بعرض سعر" },
        ],
        cta: "اطلب عرض سعر",
      },
      {
        title: "الترجمة والترجمة الفورية",
        tagline: "ترجمة تحريرية وشفوية عامة وتجارية للتواصل التجاري والاجتماعات والوثائق والمواقع الإلكترونية والعروض التقديمية والتعامل مع العملاء وغيرها من الأغراض غير المنظمة.",
        price: "ابتداءً من $0.12 USD/كلمة",
        priceNote: "الترجمة الفورية ابتداءً من $40 USD/ساعة",
        meta: "English | Українська | العربية | Other Languages",
        featured: ["ترجمة الأعمال", "ترجمة المستندات", "الترجمة عبر الفيديو", "الترجمة عبر الهاتف", "تعريب المواقع"],
        moreLabel: "عرض جميع الخدمات اللغوية",
        groups: [
          {
            heading: "الترجمة",
            items: [
              "الإنجليزية ↔ الأوكرانية",
              "أزواج لغات أخرى عند الطلب",
              "الإنجليزية ↔ العربية",
              "ترجمة مستندات الأعمال",
              "ترجمة البريد الإلكتروني",
              "ترجمة المواقع الإلكترونية",
              "ترجمة العروض التقديمية",
              "ترجمة المواد التسويقية",
              "ترجمة أوصاف المنتجات",
              "ترجمة مراسلات العملاء",
              "النماذج والاستبيانات",
              "السياسات والإجراءات",
              "المراسلات العامة",
              "تدقيق المستندات المترجمة",
              "تحرير الترجمات",
              "التعريب",
              "مراجعة الترجمة الآلية",
              "ترجمة الأعمال العاجلة",
              "الترجمة خارج ساعات العمل",
            ],
          },
          {
            heading: "الترجمة الفورية",
            items: [
              "الترجمة الفورية عن بُعد",
              "الترجمة عبر الهاتف",
              "الترجمة عبر الفيديو",
              "ترجمة اجتماعات الأعمال",
              "ترجمة المواعيد",
              "ترجمة خدمة العملاء",
              "الترجمة المجتمعية",
              "الترجمة المجدولة",
              "ترجمة شفوية تجارية عاجلة",
              "الترجمة خارج ساعات العمل",
            ],
          },
        ],
        pricing: [
          { label: "الترجمة القياسية", value: "ابتداءً من $0.12/كلمة" },
          { label: "مشاريع أعمال مخصصة", value: "اطلب عرض سعر" },
          { label: "ترجمة عاجلة خلال 24 ساعة", value: "السعر القياسي + 35%" },
          { label: "أقل من 6 ساعات", value: "السعر القياسي + 50%" },
          { label: "ترجمة أعمال عاجلة", value: "عرض سعر مخصص" },
          { label: "ترجمة شفوية تجارية مجدولة", value: "ابتداءً من $40/ساعة" },
          { label: "ترجمة شفوية تجارية ذات أولوية", value: "ابتداءً من $55/ساعة" },
          { label: "ترجمة شفوية تجارية خارج ساعات العمل", value: "ابتداءً من $65/ساعة" },
        ],
        note: "لا تقدم VCK Business Lab خدماتها القياسية للترجمة التحريرية أو الشفوية على أنها معتمدة أو محلفة أو معتمدة قضائيًا أو قانونية أو معتمدة رسميًا ما لم يُذكر ذلك صراحةً لمشروع محدد وتنفذ من قبل مختص مؤهل تأهيلاً مناسبًا.",
        cta: "اطلب عرض سعر للخدمات اللغوية",
      },
      {
        title: "دعم العملاء متعدد اللغات",
        tagline: "دعم عملاء وإداري متعدد اللغات يساعد الشركات على التواصل باحترافية مع العملاء عبر اللغات والمناطق الزمنية.",
        price: "ابتداءً من $35 USD/ساعة",
        meta: "English | Українська | العربية | Other Languages",
        featured: ["دعم العملاء متعدد اللغات", "متابعة العملاء", "حجز المواعيد", "التواصل عبر البريد", "تنسيق العملاء الدوليين"],
        moreLabel: "عرض جميع الخدمات متعددة اللغات",
        groups: [
          {
            heading: null,
            items: [
              "المراسلات متعددة اللغات عبر البريد",
              "دعم العملاء عبر البريد الإلكتروني",
              "التواصل مع العملاء",
              "متابعة العملاء",
              "جدولة المواعيد",
              "تذكيرات المواعيد",
              "تحديث معلومات العملاء",
              "تهيئة العملاء الجدد",
              "دعم إداري متعدد اللغات",
              "التواصل التجاري عبر الثقافات",
              "تنسيق العملاء الدوليين",
              "دعم الدردشة المباشرة",
              "دعم خدمة العملاء",
              "دعم الأسئلة الشائعة",
              "تحديثات CRM",
              "صيانة قواعد البيانات",
              "تنسيق الخدمات",
              "متابعة الطلبات",
              "استقبال الشكاوى والمشكلات",
              "تنسيق التصعيد",
              "مراسلات الأعمال متعددة اللغات",
              "إعداد مستندات متعددة اللغات",
              "التنسيق عبر المناطق الزمنية الدولية",
            ],
          },
        ],
        pricing: [
          { label: "الدعم القياسي متعدد اللغات", value: "ابتداءً من $35/ساعة" },
          { label: "الدعم ذو الأولوية", value: "ابتداءً من $50/ساعة" },
          { label: "الدعم الشهري المستمر", value: "باقة مخصصة" },
        ],
        cta: "أنشئ باقة دعم مخصصة",
      },
      {
        title: "خدمات المستندات والمكتب والمشاريع",
        tagline: "إعداد وتنسيق وتنظيم المستندات باحترافية، والبحث ودعم المشاريع للشركات والمهنيين.",
        price: "ابتداءً من $30 USD/ساعة",
        featured: ["تنسيق Word وPDF", "Excel وأدوات التتبع", "العروض التقديمية", "مستندات الأعمال", "البحث ودعم المشاريع"],
        moreLabel: "عرض جميع خدمات المستندات",
        groups: [
          {
            heading: "المستندات",
            items: [
              "تنسيق Microsoft Word",
              "إعداد PDF",
              "تنسيق PDF",
              "النماذج",
              "المستندات القابلة للتعبئة",
              "قوالب الأعمال",
              "الخطابات المهنية",
              "التقارير",
              "حزم مستندات الاجتماعات",
              "تنسيق السير الذاتية",
              "تنسيق خطابات التقديم",
              "التدقيق اللغوي",
              "تنظيف المستندات",
              "إعادة تصميم المستندات",
              "تحويل الملفات",
              "الأرشفة الرقمية",
              "تنظيم المستندات",
            ],
          },
          {
            heading: "جداول البيانات",
            items: ["جداول Excel", "أدوات التتبع", "تنظيم البيانات", "متتبعات المصروفات", "متتبعات الفواتير", "متتبعات الميزانية", "قوائم جهات الاتصال", "متتبعات المشاريع", "متتبعات المواعيد النهائية"],
          },
          {
            heading: "العروض التقديمية والتصميم",
            items: ["عروض PowerPoint", "تنسيق العروض التقديمية", "مواد أعمال Canva", "نشرات الأعمال", "الكتيبات الأساسية", "رسومات وسائل التواصل", "القوالب المهنية"],
          },
          {
            heading: "دعم المشاريع والبحث",
            items: ["أبحاث السوق", "أبحاث المنافسين", "أبحاث الموردين", "أبحاث المنتجات", "البحث عبر الإنترنت", "جمع البيانات", "جداول المقارنة", "بناء قوائم جهات الاتصال", "إدارة المشاريع", "إدارة المواعيد النهائية", "تنسيق المتابعات", "ملخصات الأبحاث"],
          },
        ],
        pricing: [
          { label: "المشاريع بالساعة", value: "ابتداءً من $30/ساعة" },
          { label: "المستندات بسعر ثابت", value: "متاحة بعرض سعر" },
          { label: "المشاريع الكبيرة", value: "عرض سعر مخصص" },
        ],
        cta: "اطلب عرض سعر للمشروع",
      },
      {
        title: "إنشاء المواقع الإلكترونية ودعمها",
        tagline:
          "مواقع إلكترونية احترافية للأعمال الحديثة — يمكننا ببساطة تصميمها وإنشاءها لك، أو متابعة تحديثها ودعمها على المدى الطويل من خلال باقة دعم شهرية.",
        price: "ابتداءً من $40 USD/ساعة",
        priceNote: "الإنشاء لمرة واحدة — بعرض سعر خاص",
        featured: ["مواقع الأعمال", "صفحات الهبوط", "إعادة تصميم المواقع", "إعداد المتاجر الإلكترونية", "الصيانة المستمرة"],
        moreLabel: "جميع خدمات المواقع",
        groups: [
          {
            heading: "التصميم والإنشاء — مشاريع لمرة واحدة",
            items: [
              "تصميم وإنشاء مواقع الأعمال",
              "إنشاء صفحات الهبوط",
              "إعادة تصميم وتحديث المواقع",
              "تصاميم متجاوبة مع الجوال",
              "إعداد المتاجر الإلكترونية",
              "إعداد نماذج التواصل والحجز",
              "إعداد المواقع متعددة اللغات",
              "صفحات الأعمال والمعارض",
              "المدونات وأقسام المحتوى",
              "صفحات القوائم وقوائم الأسعار والكتالوجات",
            ],
          },
          {
            heading: "الدعم المستمر — مع أي باقة شهرية",
            items: [
              "تحديثات وتعديلات المحتوى",
              "تحديث الإضافات والقوالب والمنصة",
              "الصيانة الدورية للموقع",
              "النسخ الاحتياطي وفحوصات الأمان",
              "تنسيق النطاق والاستضافة",
              "إعداد أساسي لتحسين محركات البحث",
              "التحليلات وفحوصات الأداء",
              "إصلاح أعطال الموقع",
            ],
          },
        ],
        pricing: [
          { label: "تحديثات ودعم الموقع", value: "ابتداءً من $40/ساعة" },
          { label: "إنشاء موقع لمرة واحدة", value: "اطلب عرض سعر" },
          { label: "عناية مستمرة مع باقة شهرية", value: "انظر الباقات" },
        ],
        note: "يمكننا ببساطة إنشاء موقعك الإلكتروني كمشروع لمرة واحدة — أو دمجه مع أي باقة دعم مستمر لنُبقيه محدثًا وآمنًا وينمو مع عملك شهرًا بعد شهر.",
        cta: "ناقش موقعك الإلكتروني",
      },
      {
        title: "دعم القادمين الجدد والطلاب الدوليين",
        tagline: "دعم إداري ولغوي بعد الوصول في كندا.",
        price: "ابتداءً من $30 USD/ساعة",
        meta: "English | Українська | العربية | Other Languages",
        featured: [
          "حجز المواعيد والجدولة",
          "المساعدة في المكالمات والبريد الإلكتروني",
          "ترجمة عامة وترجمة فورية",
          "دعم عملي بعد الوصول",
        ],
        moreLabel: "عرض التفاصيل",
        groups: [
          {
            heading: "ما يشمله هذا الدعم",
            items: [
              "دعم إداري ولغوي عملي متعدد اللغات للقادمين الجدد والطلاب الدوليين والأفراد ذوي الكفاءة المحدودة في الإنجليزية وهم يتنقلون في الحياة اليومية في كندا.",
            ],
          },
          {
            heading: "التنسيق اليومي",
            items: [
              "حجز المواعيد والجدولة",
              "المساعدة في المكالمات الهاتفية والبريد الإلكتروني",
              "التواصل مع الشركات الكندية ومقدمي الخدمات",
              "المتابعات والتنسيق العام",
            ],
          },
          {
            heading: "اللغة والمستندات",
            items: [
              "المساعدة في فهم المراسلات العامة والمستندات اليومية",
              "ترجمة عامة وترجمة فورية",
              "دعم متعدد اللغات للشؤون الإدارية اليومية",
            ],
          },
          {
            heading: "الاستقرار بعد الوصول",
            items: [
              "المساعدة في التواصل مع المدارس والكليات وأصحاب العمل والمنظمات الأخرى",
              "مساعدة إدارية عامة",
              "المساعدة في العثور على الخدمات والموارد المتاحة للعامة",
              "دعم عملي بعد الوصول",
            ],
          },
        ],
        pricing: [
          { label: "دعم بالساعة", value: "ابتداءً من $30/ساعة" },
          { label: "طلبات ذات أولوية", value: "ابتداءً من $45/ساعة" },
          { label: "دعم مستمر", value: "عرض سعر مخصص" },
        ],
        note: "مهم: تقدم VCK Business Lab دعمًا إداريًا ولغويًا وعمليًا عامًا فقط. لا نقدم استشارات أو تمثيلًا في شؤون الهجرة أو المواطنة أو المسائل القانونية أو الضريبية أو المالية أو الطبية أو التوظيف أو التعليم أو غيرها من الخدمات المهنية الخاضعة للتنظيم. وعند الحاجة إلى مساعدة مهنية خاضعة للتنظيم، يجب على العملاء استشارة مختص مرخص مناسب.",
        cta: "اطلب عرض سعر",
      },
      {
        title: "دعم الأولوية والطوارئ 24/7",
        tagline: "دعم عاجل متعدد اللغات وإداري ومستندات وترجمة وأعمال للعملاء الذين لا يمكنهم الانتظار حتى ساعات العمل العادية.",
        price: "ابتداءً من $65 USD/ساعة",
        meta: "متاح حول العالم، حسب توفر الفريق.",
        featured: ["ترجمة أعمال عاجلة", "ترجمة فورية عاجلة", "مستندات اللحظة الأخيرة", "دعم الأعمال بعد ساعات العمل", "دعم عطلات نهاية الأسبوع والأعياد"],
        moreLabel: "عرض خدمات الطوارئ",
        groups: [
          {
            heading: null,
            items: [
              "ترجمة الأعمال العاجلة",
              "ترجمة شفوية تجارية عاجلة",
              "إعداد مستندات اللحظة الأخيرة",
              "تنسيق المستندات الطارئ",
              "العروض التقديمية العاجلة",
              "الدعم الإداري بعد ساعات العمل",
              "الدعم الإداري في عطلة نهاية الأسبوع",
              "دعم أيام العطل",
              "دعم المناطق الزمنية الدولية",
              "التواصل العاجل مع العملاء",
              "التواصل العاجل متعدد اللغات",
              "تنسيق الاجتماعات الطارئ",
              "الجدولة في اللحظة الأخيرة",
              "أبحاث الأعمال العاجلة",
              "دعم خدمة العملاء الطارئ",
            ],
          },
        ],
        pricing: [
          { label: "الدعم ذو الأولوية", value: "ابتداءً من $45/ساعة" },
          { label: "دعم ما بعد ساعات العمل", value: "ابتداءً من $55/ساعة" },
          { label: "دعم الطوارئ 24/7", value: "ابتداءً من $65/ساعة" },
          { label: "حرج / استجابة خلال ساعتين", value: "ابتداءً من $75/ساعة" },
          { label: "دعم الطوارئ في الأعياد الكبرى", value: "ابتداءً من $85/ساعة" },
          { label: "الحد الأدنى لرسوم خدمة الطوارئ", value: "$65 USD" },
        ],
        note: "تخضع خدمات الطوارئ وما بعد ساعات العمل للتوفر. يتم تأكيد وقت الاستجابة قبل تحصيل الرسوم من العميل.",
        cta: "اطلب دعم الطوارئ",
      },
    ],
    plans: [
      {
        price: "ابتداءً من $300 USD/شهر",
        fit: "الأفضل لرواد الأعمال والمهنيين الذين يحتاجون دعمًا افتراضيًا عرضيًا.",
        features: ["حتى 10 ساعات دعم", "ساعات إضافية متاحة برسوم إضافية", "دعم إداري", "الجدولة", "المستندات", "دعم البريد الإلكتروني"],
        cta: "اطلب باقة Essential",
      },
      {
        price: "ابتداءً من $575 USD/شهر",
        fit: "الأفضل للشركات التي تحتاج دعمًا أسبوعيًا منتظمًا.",
        features: ["حتى 20 ساعة دعم", "ساعات إضافية متاحة برسوم إضافية", "دعم إداري", "دعم متعدد اللغات", "تنسيق الاجتماعات", "تتبع المشاريع", "جدولة ذات أولوية"],
        cta: "اطلب باقة Professional",
      },
      {
        price: "ابتداءً من $1,100 USD/شهر",
        fit: "للمديرين التنفيذيين والشركات التي تتطلب دعمًا مستمرًا عالي المستوى.",
        features: ["حتى 60 ساعة دعم", "ساعات إضافية متاحة برسوم إضافية", "إدارة تنفيذية", "دعم عملاء متعدد اللغات", "تنسيق الاجتماعات والمشاريع", "استجابة ذات أولوية", "هيكل دعم مخصص"],
        cta: "اطلب باقة Executive",
      },
      {
        price: "تسعير مخصص",
        fit: "للشركات التي تتطلب دعمًا دوليًا متعدد اللغات بساعات ممتدة أو بأحجام أكبر.",
        features: ["ساعات شهرية مخصصة", "ساعات إضافية متاحة برسوم إضافية", "دعم بالإنجليزية والأوكرانية والعربية ولغات أخرى", "مساعدة ذات أولوية", "توفر بساعات ممتدة", "أسعار طوارئ مخفّضة", "سير عمل مخصص", "فئات خدمات متعددة", "دعم أعمال مخصص"],
        cta: "اطلب عرض سعر مخصص",
      },
    ],
    steps: [
      { title: "تواصل", text: "حدد موعد استشارة تعريفية وناقش احتياجات أعمالك." },
      { title: "خصص", text: "اختر نوع ومستوى الدعم الأنسب لك." },
      { title: "فوّض", text: "أرسل المهام الإدارية التي تريد رفعها عن كاهلك." },
      { title: "ركّز", text: "اقضِ وقتًا أطول مع عملائك ومشاريعك ونمو أعمالك بينما تتولى VCK التفاصيل الإدارية." },
    ],
    why: [
      { title: "خدمة مهنية وموثوقة", text: "دعم ثابت ومنتظم يمكنك بناء جدولك عليه." },
      { title: "دعم افتراضي مرن", text: "دعم يتوسع أو يتقلص مع عبء عملك — دون عقود جامدة." },
      { title: "نهج دقيق في التفاصيل", text: "كل مهمة تُعالج بعناية وتُفحص وتُسلَّم بمعايير عالية." },
      { title: "سري افتراضيًا", text: "تُعالج معلومات الأعمال بسرية صارمة وبضمانات معقولة، وتتوفر اتفاقيات عدم الإفصاح عند الحاجة." },
      { title: "تواصل واضح", text: "تواصل مهني وسريع وشفاف في كل خطوة." },
      { title: "مخصص لك", text: "دعم مصمم حول أدوات كل عميل وتفضيلاته وطريقة عمله." },
      { title: "دون توظيف بدوام كامل", text: "دعم بمستوى رفيع دون تكلفة والتزام الموظف." },
      { title: "مستمر أو حسب المشروع", text: "متاح للدعم الشهري المستمر أو المهام لمرة واحدة." },
      { title: "خدمة افتراضية عالمية", text: "نخدم العملاء في كندا والولايات المتحدة وأوروبا ودوليًا." },
    ],
    clients: ["رواد الأعمال", "الشركات الصغيرة", "المستشارون", "المديرون التنفيذيون", "المهنيون", "الشركات الناشئة", "المقاولون المستقلون", "أصحاب الأعمال المشغولون", "المنظمات التي تحتاج دعمًا إداريًا مؤقتًا", "الأفراد", "القادمون الجدد إلى كندا", "الطلاب الدوليون", "العائلات الدولية", "المهنيون المنتقلون إلى كندا", "الأفراد ذوو الكفاءة المحدودة في الإنجليزية", "العملاء الناطقون بالأوكرانية", "العملاء الناطقون بالعربية"],
    faqs: [
      { q: "ما هو المساعد الإداري الافتراضي؟", a: "المساعد الإداري الافتراضي هو محترف يقدم دعمًا إداريًا وتنظيميًا وتجاريًا عن بُعد. تحصل على نفس المساعدة الموثوقة عالية الجودة التي تتوقعها من مسؤول إداري في المكتب — دون النفقات العامة أو المعدات أو التزام التوظيف بدوام كامل." },
      { q: "هل يمكنني توظيف VCK Business Lab لبضع ساعات فقط؟", a: "نعم. الدعم مرن بطبيعته. يمكنك إشراك VCK لبضع ساعات من المساعدة العرضية أو مشروع واحد أو مهمة قصيرة الأمد — لا يلزم حد أدنى من الالتزام الشهري." },
      { q: "هل تقدمون دعمًا شهريًا مستمرًا؟", a: "نعم. توفر باقتا Professional وExecutive مساعدة أسبوعية وشهرية منتظمة للعملاء الذين يريدون دعمًا ثابتًا وموثوقًا لإدارتهم اليومية." },
      { q: "هل يمكنكم العمل مع عملاء دوليين؟", a: "بالتأكيد. تُقدَّم جميع الخدمات افتراضيًا بنسبة 100%، مما يتيح لـ VCK Business Lab دعم العملاء في كندا والولايات المتحدة وأوروبا ودوليًا. نرحب دائمًا باستفسارات العملاء الدوليين." },
      { q: "هل تقدمون مشاريع لمرة واحدة؟", a: "نعم. تغطي المشاريع المخصصة المهام لمرة واحدة مثل تنسيق المستندات والبحث وتنسيق الفعاليات وتنظيم سير العمل، وكل منها بعرض سعر واضح ومحدد النطاق قبل بدء العمل." },
      { q: "كيف أرسل لكم المستندات والمعلومات بأمان؟", a: "يتم تبادل المستندات عبر قنوات آمنة قائمة على الأذونات مثل التخزين السحابي المشفر ومنصات مشاركة الملفات. يقتصر الوصول بصرامة على ما يلزم لتعاونك، وتتوفر اتفاقيات السرية دائمًا عند الطلب." },
      { q: "ما البرامج التي تعملون بها؟", a: "تعمل VCK بإتقان مع Microsoft 365 — بما في ذلك Word وExcel وOutlook وTeams وPowerPoint — بالإضافة إلى Google Workspace وأدوات PDF وAcrobat وZoom ومعظم منصات الأعمال الشائعة. إذا كانت أعمالك تستخدم أداة معينة، فما عليك سوى السؤال." },
      { q: "هل يمكنكم المساعدة في Microsoft Word وExcel وOutlook وTeams ومستندات PDF؟", a: "نعم — هذه هي جوهر عملنا. ويشمل ذلك تنسيق مستندات Word الاحترافية وجداول Excel وأدوات التتبع وإدارة البريد والتقويم في Outlook وتنسيق اجتماعات Teams وإعداد وتنسيق ملفات PDF." },
      { q: "هل تبقى مستندات أعمالي سرية؟", a: "دائمًا. التعامل السري مع معلومات الأعمال هو مبدأ تأسيسي في VCK Business Lab. لا تتم مشاركة مستنداتك أو مناقشتها أو استخدامها أبدًا خارج نطاق تعاونك، ويسعدنا إضفاء الطابع الرسمي على ذلك باتفاقية عدم إفصاح." },
      { q: "كيف تعمل الفوترة؟", a: "التسعير شفاف ومخصص — كل تعاون يستخدم أسعار بداية تُنهى بعد استشارة قصيرة. تُفوتر الباقات المستمرة شهريًا، وتُسعَّر المشاريع لمرة واحدة بنطاق ثابت، ولا يلزم أي عقود طويلة الأمد." },
      { q: "كيف أدفع مقابل الخدمات؟", a: "بعد تأكيد متطلبات الخدمة والنطاق والسعر، سترسل لك VCK Business Lab رابط دفع آمنًا مباشرة. تُقدَّم تعليمات الدفع قبل بدء العمل أو وفقًا لشروط الدفع المتفق عليها لخدمتك — ولا يوفر الموقع صفحة دفع عامة." },
      { q: "هل تعملون مع الأفراد والقادمين الجدد أم مع الشركات فقط؟", a: "مع كليهما. إلى جانب خدمات الأعمال، تقدم VCK الدعم الشخصي ودعم القادمين الجدد — المساعدة اللغوية، والمساعدة في التواصل مع البنوك وشركات التأمين والمرافق والمُلاّك والمدارس، والدعم الإداري اليومي للأفراد والعائلات والقادمين الجدد إلى كندا." },
      { q: "هل يمكنكم المساعدة في طلبات الهجرة أو المسائل القانونية أو النصائح المالية؟", a: "لا — ونحن حريصون على توضيح ذلك. لا تقدم VCK Business Lab نصائح في الهجرة أو الشؤون القانونية أو المالية أو التأمينية أو الضريبية أو الطبية، ولا نُعد أو نقدم طلبات الهجرة. تغطي خدمات الدعم الشخصي لدينا التواصل والتنظيم والإدارة فقط. وعندما يلزم مختص مرخص أو خاضع للتنظيم، سنخبرك بذلك دائمًا ونساعدك في العثور عليه." },
    ],
    testimonials: [
      {
        quote:
          "Working with this team was a smooth and professional experience from start to finish. They created a modern, clear, and user-friendly website for my legal practice in Ukraine that presents my services in a professional way and makes it easy for clients to find the information they need.\n\nThey listened carefully to my requirements, communicated clearly throughout the process, and delivered a website that reflects my work and professional image very well.\n\nI am very satisfied with the result and would gladly recommend their services to other professionals and businesses looking for reliable website and digital support.",
        name: "Anton",
        detail: "محامٍ، أوكرانيا",
      },
    ],
    loyaltyTiers: [
      { months: "شهر واحد", hours: "3 ساعات مجانية", note: "طريقة رائعة للبدء وتجربة دعم VCK مع القليل الإضافي علينا.", extras: [] },
      { months: "3 أشهر", hours: "8 ساعات مجانية", extras: ["حزمة ترحيب مجانية من VCK", "جدولة ذات أولوية", "دعم مرن عبر الخدمات المؤهلة"] },
      { months: "6 أشهر", hours: "18 ساعة مجانية", extras: ["حزمة ترحيب فاخرة من VCK", "جدولة ذات أولوية", "حجز مشاريع بأولوية", "أسعار تفضيلية لخدمات عاجلة مختارة"] },
      { months: "12 شهرًا", hours: "36 ساعة مجانية", extras: ["حزمة ترحيب فاخرة من VCK", "جدولة ذات أولوية", "حجز مشاريع بأولوية", "أسعار طوارئ تفضيلية", "جلسة تخطيط دعم سنوية مجانية", "مزايا حصرية للعملاء الدائمين"] },
    ],
    loyaltyServices: ["الدعم الإداري الافتراضي", "دعم المديرين التنفيذيين", "دعم العملاء متعدد اللغات", "المساعدة في المستندات والمشاريع", "خدمات الترجمة", "خدمات أعمال VCK المؤهلة الأخرى"],
    marquee: ["الدعم الإداري الافتراضي", "إدارة تقويم المديرين", "المستندات ودعم الأعمال", "تنسيق الاجتماعات", "تنسيق الأعمال والمشاريع", "المساعدة التنفيذية السرية"],
    comparison: {
      columns: ["Essential", "Professional", "Executive", "Global Priority"],
      rows: [
        { label: "ساعات الدعم الشهرية", values: ["حتى 10", "حتى 20", "حتى 60", "مخصصة"] },
        { label: "الدعم الإداري", values: [true, true, true, true] },
        { label: "الدعم متعدد اللغات", values: [false, true, true, true] },
        { label: "تنسيق الاجتماعات والمشاريع", values: [false, true, true, true] },
        { label: "الإدارة التنفيذية", values: [false, false, true, true] },
        { label: "الاستجابة والجدولة ذات الأولوية", values: [false, true, true, true] },
        { label: "التوفر بساعات ممتدة", values: [false, false, false, true] },
        { label: "أسعار طوارئ مخفّضة", values: [false, false, false, true] },
        { label: "هيكل دعم مخصص", values: [false, false, true, true] },
        { label: "السعر", values: ["من $300/شهر", "من $575/شهر", "من $1,100/شهر", "مخصص"] },
      ],
    },
    aboutChapters: [
      { title: "الفرق البوتيكي", text: "تبقى VCK بوتيكًا عن قصد. تعمل مباشرة مع محترف مخصص يتعلم كيفية سير أعمالك — وليس مع مجموعة متغيرة من المساعدين المجهولين. كل تفصيلة وتفضيل ومعيار يُتذكر ويُحترم." },
      { title: "سرية راسخة", text: "الثقة هي أساس كل تعاون. تُعالج معلومات الأعمال السرية بعناية، وتُحمى عبر قنوات آمنة، ولا تُناقش أبدًا خارج نطاق عملك المشترك." },
      { title: "دقة لا تقبل المساومة", text: "من مستند منسق بإتقان إلى تقويم منسق بلا أخطاء، المعيار واحد في كل مرة: دقة وإتقان والتزام بالمواعيد. التفاصيل هي العمل." },
    ],
    aboutValues: [
      { title: "الاحترافية", text: "معيار مصقول وموثوق في كل تفاعل وكل نتيجة." },
      { title: "التنظيم", text: "هيكل ونظام للبريد والتقويمات والملفات وسير العمل." },
      { title: "التواصل", text: "واضح وسريع ومهني — تعرف دائمًا أين تقف الأمور." },
      { title: "خدمة العملاء", text: "دعم منتبه وشخصي مصمم حول طريقة عمل كل عميل." },
    ],
  },
};
